import React, { PureComponent } from 'react';
import DatePicker from 'react-datepicker';
import CalendarBlankIcon from 'mdi-react/CalendarBlankIcon';
import PropTypes from 'prop-types';

class DatePickerField extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.instanceOf(Date),
    ]),
    placeholder: PropTypes.string,
    meta: PropTypes.shape({
      touched: PropTypes.bool,
      error: PropTypes.string,
    }),
    dateFormat: PropTypes.string,
    showTimeInput: PropTypes.bool,
    readOnly: PropTypes.bool,
  };

  static defaultProps = {
    value: '',
    placeholder: '',
    meta: null,
    dateFormat: 'dd/MM/yyyy',
    showTimeInput: false,
    readOnly: false,
  };

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(date) {
    const { onChange } = this.props;
    onChange(date);
  }

  render() {
    const {
      value,
      placeholder,
      meta,
      dateFormat,
      showTimeInput,
      readOnly,
    } = this.props;
    return (
      <>
        <div className="date-picker">

          <DatePicker
            minDate={new Date(new Date().getFullYear() - 80, 1, 1)}
            selected={value ? new Date(value) : null}
            className="form__form-group-datepicker"
            placeholderText={placeholder}
            onChange={this.handleChange}
            dateFormat={`${dateFormat}${showTimeInput ? ' HH:mm' : ''}`}
            timeInputLabel="Hora:"
            dropDownMode="select"
            showYearDropdown
            showTimeInput={showTimeInput}
            showTimeSelect={showTimeInput}
            readOnly={readOnly}
          />

        </div>

        <div className="form__form-group-icon">
          <CalendarBlankIcon />
        </div>
        {meta.touched && meta.error && <span className="form__form-group-error">{meta.error}</span>}
      </>
    );
  }
}

const renderDatePickerField = (props) => {
  const { input } = props;
  return (
    <DatePickerField {...input} {...props} />
  );
};

renderDatePickerField.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    name: PropTypes.string,
  }).isRequired,
};

export default renderDatePickerField;
